import React from "react";
import style from "./style.module.css";
import useTranslation from "next-translate/useTranslation";
import formatUrl from "utils/FormatUrl";

function index({
  title,
  desc,
  btnText,
  lang,
  btnLink,
  isPNBlock,
  from404,
  t,
}: {
  title: string;
  desc: string;
  btnText: string;
  lang: string;
  btnLink?: string;
  isPNBlock?: boolean;
  from404?: boolean;
  t?: any;
}) {
  return (
    <div
      className={`${style.cardContrainer} ${
        isPNBlock ? style.cardProjetNeuf : ""
      } ${from404 ? style.cardsFrom404 : ""}`}
    >
      <div className={style.infoContainer}>
        <p
          className={`${style.title} ${isPNBlock ? style.titleProjetNeuf : ""}`}
        >
          {t(title)}
        </p>
        <p
          className={`${style.description} ${
            isPNBlock ? style.descProjetNeuf : ""
          }`}
        >
          {t(desc)}
        </p>
      </div>
      <div className={style.btnContainer}>
        <a
          href={formatUrl(`/${btnLink}`, lang)}
          rel={
            btnLink?.includes("list") ||
            btnLink?.includes("map") ||
            btnLink?.includes("?") ||
            btnLink?.includes("conditions") ||
            btnLink?.includes("contact")
              ? "noindex, nofollow, noreferrer"
              : "dofollow"
          }
          className={style.btnAction}
        >
          {t(btnText)}
        </a>
      </div>
    </div>
  );
}

export default index;
